import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CheckoutModalService } from 'src/app/course/services/checkout-modal.service';

@Component({
  selector: 'app-about-course-modal',
  templateUrl: './about-course-modal.component.html',
  styleUrls: ['./about-course-modal.component.scss']
})
export class AboutCourseModalComponent {
  bsModalRef = inject(BsModalRef);
  private checkoutModalService = inject(CheckoutModalService);

  course: any;

  closeModal() {
    this.bsModalRef.hide();
  }

  onBuyClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.checkoutModalService.buyCourse(this.course);
  }
}
